import React, { useState } from 'react';

import { t } from 'i18next';

import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

type Famille = string | null;

interface DropdownProps {
  options: {
    value: string;
    label: string;
    disabled: boolean;
    name: string;
    id: string;
  }[];
  onChange: (value: string) => void;
  families: (Famille | undefined)[] | undefined;
}

const DropDownContrats: React.FC<DropdownProps> = ({ options, onChange, families }) => {
  const [open, setOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState('Tous les contrats');

  const handleOpen = () => {
    setOpen(!open);
  };

  const displayCurrentFilter = () => {
    switch (currentFilter) {
      case 'assurancevie':
        return t('dropDownContrats.lifeInsurance');
      case 'retraite':
        return t('dropDownContrats.retirement');
      case 'livret':
        return t('dropDownContrats.savingsAccount');
      case 'defiscalisation':
        return t('dropDownContrats.taxExemption');
      case 'immobilier':
        return t('dropDownContrats.realEstate');
      case 'bourse':
        return t('dropDownContrats.stockMarket');
      default:
        return t('dropDownContrats.allContracts');
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentFilter(event.target.value);
    onChange(event.target.value);
    setOpen(false);
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: event.target.value === 'touslescontrats' ? 'tous les contrats' : event.target.value,
      event_detail_1: 'menu deroulant',
    });
  };

  return (
    <div className={styles.dropDownContrats}>
      <button className={styles.boxButtonDropdown} onClick={handleOpen}>
        <span className={styles.colorTextButtonDropdown}>{displayCurrentFilter()}</span>
        {open ? (
          <i className="totem-icon totem-icon-chevron-up-big" />
        ) : (
          <i className="totem-icon totem-icon-chevron-down-big" />
        )}
      </button>

      <div className={styles.boxMenuContent} style={{ display: open ? 'flex' : 'none' }}>
        <div className={styles.boxTitleMenu}>
          <span className={styles.colorTitleMenu}>{t('dropDownContrats.label')}</span>
        </div>
        <div className={styles.boxRadioButton}>
          <label className={styles.inputStyle} htmlFor="checkboxAll">
            <input
              className={styles.hiddenCheckbox}
              type="radio"
              id="checkboxAll"
              name="contrats-filter"
              value="touslescontrats"
              defaultChecked={currentFilter === 'Tous les contrats'}
              onChange={handleInputChange}
            />
            <div className={styles.customCheckbox}></div>
            {t('dropDownContrats.allContracts')}
          </label>

          {options.map((value) => {
            return (
              <label className={styles.inputStyle} htmlFor={value.id} key={value.id}>
                <input
                  className={styles.hiddenCheckbox}
                  checked={currentFilter === value.value}
                  type="radio"
                  id={value.id}
                  name={value.name}
                  value={value.value}
                  disabled={!families?.includes(value.value?.toLocaleUpperCase())}
                  onChange={(event) => handleInputChange(event)}
                />
                <div
                  className={`${styles.customCheckbox} ${
                    !families?.includes(value.value?.toLocaleUpperCase()) ? styles.customCheckboxDisabled : ''
                  }`}
                ></div>
                {value.label}
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DropDownContrats;
